//@ts-check
// Polyfills
//@ts-ignore
window['process'] = { env: {} }
window['Buffer'] = require('buffer').Buffer
window['f'] = fetch

import React from "react"
import ReactDOM from "react-dom"


// Must use require since it is using a polyfill.
var App = require("./app-components/app").default

var configRegexp = /[?/&]config=([^&]+)/
if (location.search.match(configRegexp)) {
  var config = decodeURIComponent(location.search).match(configRegexp)[1]
  try {
    var y = JSON.parse(config)
    window["config"] = {
      ...(window["config"] || {}),
      ...JSON.parse(config),
    }

  } catch (err) {
    try {
      const configData = atob(config)
      window["config"] = {
        ...(window["config"] || {}),
        ...JSON.parse(configData),
      }
    } catch (err) {
      alert("config is not a valid json")
    }
  }
}
if (!window["config"]) {
  alert(
    "cannot start app without config object configurations. Please use config.js",
  )
}
if (!window["config"].BACKEND_DOMAIN) {
  alert(
    "cannot start app without BACKEND_DOMAIN configurations. Please use config.js or environment variable",
  )
}

import StylesWrapper from "./utils/stylesWrapper"
import ThemeProviderWrapper from "./themeProvider/ThemeProviderWrapper"
var WhatToRender = <StylesWrapper>
  <ThemeProviderWrapper>
    <App />
  </ThemeProviderWrapper>
</StylesWrapper>
var root = ReactDOM.createRoot(document.getElementById("app"))
root.render(WhatToRender)
// ReactDOM.render(
// whatToRender
//   document.getElementById("app"),
// )
